import { Directive, HostListener } from '@angular/core';
import { EMPTY } from 'rxjs';

@Directive({
  selector: '[appBlockCopyPasteInput]',
})
export class BlockCopyPasteInputDirective {
  constructor() {
    EMPTY;
  }

  @HostListener('paste', ['$event']) blockPaste(e: KeyboardEvent) {
    e.preventDefault();
  }

  @HostListener('copy', ['$event']) blockCopy(e: KeyboardEvent) {
    e.preventDefault();
  }

  @HostListener('cut', ['$event']) blockCut(e: KeyboardEvent) {
    e.preventDefault();
  }
}
